import { createSlice } from '@reduxjs/toolkit';

import { ExternalInvitation } from '../external-invitation/entities/external-invitation.entity';
import { ImpactCo2AnswerStatsPublic } from '../impact-stats/entities/stats-public.entity';
import { getExternalInvitationSurveys } from './actions/get-external-invitation-surveys.action';
import { getSurveysResults } from './actions/get-surveys-results.action';

export type ExternalInvitationSurveyState = {
  items: ExternalInvitation[];
  isFetching: boolean;
  resultsByInvitationId: { [invitationId: number]: ImpactCo2AnswerStatsPublic };
};

const initialState: ExternalInvitationSurveyState = {
  items: [],
  isFetching: false,
  resultsByInvitationId: {},
};

export const externalInvitationSurveySlice = createSlice({
  name: 'externalInvitationSurvey',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getExternalInvitationSurveys.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getExternalInvitationSurveys.fulfilled, (state, action) => {
        state.isFetching = false;
        state.items = action.payload;
      })
      .addCase(getSurveysResults.fulfilled, (state, action) => {
        state.resultsByInvitationId = action.payload;
      });
  },
});
